export default __webpack_public_path__ + "static/media/29_gallery.8d0d2f75.jpg";